import type { ParagraphFaq as ParagraphFaqData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphFaq.module.css";

/**
 * Layout 66 - `PARAGRAPH_FAQ_LAYOUT`: akordeon Q/A.
 *
 * Struktura:
 *   - Header centrowany: eyebrow (text_1) + H2 (name)
 *   - Lista kart z pytaniami - natywny `<details>`/`<summary>` (zero JS state)
 *   - Rozwinięte details pokazuje answer (HTML z TinyMCE, `dangerouslySetInnerHTML`)
 *
 * Style w local module.css - port 1:1 z WFaq.module.css.
 */
export function ParagraphFaq({
  paragraph,
}: {
  paragraph: ParagraphFaqData;
  t: ParagraphTranslations;
}) {
  if (!Array.isArray(paragraph.items) || paragraph.items.length === 0) return null;

  const eyebrow = (paragraph.hero_text ?? "").trim();
  const heading = paragraph.title;

  return (
    <section className={styles.root}>
      <div className={styles.header}>
        {eyebrow !== "" ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {heading ? <h2 className={styles.heading}>{heading}</h2> : null}
      </div>

      <ul className={styles.list}>
        {paragraph.items.map((item) => (
          <li key={item.id} className={styles.row}>
            <details className={styles.details}>
              <summary className={styles.question}>{item.question}</summary>
              <div
                className={styles.answer}
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </details>
          </li>
        ))}
      </ul>
    </section>
  );
}
